import script from "./OrderSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&setup=true&lang=js"

import "./OrderSuccess.vue?vue&type=style&index=0&id=6f1cfb23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1cfb23"]])

export default __exports__